import {
  type TrackSessionDto,
  PROCESSING_TELEMETRY_TYPES,
} from '@pitbrain/shared'
import useApi from '../../api/useApi'
import ConfigurationContext from '../../core/providers/ConfigurationContext'
import { useContext } from 'react'
import { useTrackSessionContext } from '../trackSession/TrackSessionContext'
import { mapToTrackSession } from '../load/mapToTrackSession'
import { ON_ANOTHER_TRACK } from './useCreateSession'

export const useStoredSessionLoader = () => {
  const { setTrackSessions, trackSessions } = useTrackSessionContext()

  const bffConfig = useContext(ConfigurationContext)
  const api = useApi(bffConfig)
  const loadStoredSession = async (
    fileName: string
  ): Promise<TrackSessionDto | null> => {
    const stored = await api.trackSessionApi.getTrackSessionByName(
      fileName,
      PROCESSING_TELEMETRY_TYPES
    )
    if (stored == null) return null

    const track = await api.trackApi.getTrack(stored.trackId)
    if (track == null) return stored
    if (
      trackSessions?.length &&
      trackSessions[0].track?.id !== stored.trackId
    ) {
      throw Error(ON_ANOTHER_TRACK)
    }

    const sharedLaps = await api.trackSessionApi.getSharedLapsForTrackSession(
      stored.id
    )
    const session = await mapToTrackSession(stored, track, sharedLaps ?? [])
    setTrackSessions((prevState) => [...prevState, session])
    return stored
  }

  return { loadStoredSession }
}
